import React, { useState } from "react";
import PackagingLabelingForm from "./PackagingLabelingForm";
import PackagingLabelingListview from "./PackagingLabelingListview";

const PackingLabeling = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
  const [serviceId, setServiceId] = useState("none");
  return (
    <>
      {fromIsShown ? (
        <PackagingLabelingForm addForm={setFromIsShown} update={upData}  sId={serviceId}/>
      ) : (
        <PackagingLabelingListview
          addForm={setFromIsShown}
          update={setUpData}
          sId={setServiceId}
        />
      )}
    </>
  );
};

export default PackingLabeling;
